import React, { useEffect, useRef, useState } from "react";
import SiteHead from "../component/head/SiteHead";
import SiteAppNoSSR from "../component/app/SiteAppNoSSR";
import Link from "next/link";
import { useWebsiteRoutePathname } from "../component/hooks";
import { generateLoginPath } from "../pixelmixer-webapp/src/service/AmplifyLoginService";
import Footer from "../component/footer/Footer";
import PageBreadcrumbTitle from "../component/nav/PageBreadcrumbTitle";

const CreateAccountPage = ({ nonce }) => {
  const pathname = useWebsiteRoutePathname();

  return (
    <>
      <SiteHead showNavBar={false} enableFloatingNavBar={false} nonce={nonce} />
      <div className="background-gradient">
        <div className="background-gradient-overlay"></div>

        {/* <!--===== WELCOME STARTS =======--> */}
        <div className="form-page-container login">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 m-auto">
                <PageBreadcrumbTitle pageName="Sign Up" />
                <div className="space50"></div>
                <div className="form-panel heading6">
                  <h2 className="title">
                    <ion-icon name="happy-outline" class="icons"></ion-icon>
                    Create an Account
                  </h2>
                  <div className="space16"></div>
                  <p className="text-center">Let's get you started.</p>
                  <div className="space50"></div>

                  <SiteAppNoSSR />
                  <div className="space32"></div>

                  <div className="col-md-12 text-center">
                    <p className="create-account">
                      Already have an account?&nbsp;
                      <Link
                        href={generateLoginPath(pathname)}
                        className="purple-color"
                      >
                        Login here
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===== WELCOME ENDS =======--> */}
      </div>
      <Footer includeSignup={false} />
    </>
  );
};

export default CreateAccountPage;
